import axios from 'axios';

import config from '../config/config.json';

export default axios.create({
  baseURL: config.apiUrl,
  maxContentLength: 50 * 1024 * 1024,
  timeout: 15000,
});
